import { Delete, EditNote } from "@mui/icons-material";
import { Autocomplete, Backdrop, Button, Checkbox, Chip, FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useFormik } from 'formik';
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import Loader from "../../../../../components/loader/loader";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import { Helmet } from "react-helmet-async";
import CustomdropDown from "../../../../../components/utils/dropDown/customdropDown";
const SubAccountMaster = () => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [openDialog, setOpenDialog] = useState(false)
  const [isLoader, setIsLoader] = useState(false); //loader
  const [acHeadData , setAcHeadData] = useState([])
  const [active, setActive] = useState(false)

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      flex: 1,
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "accName",
      headerName: "Account Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "subName",
      headerName: "Sub Account Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
        field: "active",
        headerName: "Status",
        disableExport: true ,
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => {
            // console.log(params)
            return(
                <div className="">
                    <Chip size='small' color={params.row.isActive ? 'success' : 'error'} label={params.row.isActive ? 'Active' : 'Inactive'}/>
                </div>
            )
            
        }
       
        
      },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableExport: true ,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className='flex justify-center w-full'>
          <IconButton onClick={()=>onEdit(params.row)} >
            <EditNote sx={{color:"#1972d2",fontSize:22}}/>
          </IconButton>
          <IconButton onClick={() => OnDelete(params.id)}>
            <Delete sx={{color:"red",fontSize:22}}/>
          </IconButton>
        </div>
      ),
    },
  ];

  const rows = _.map(data , (val , idx) => ({
    id : val.id,
    idNo:val.acc_id,
    sno: ++idx,
    accName : val.acname,
    subName : val.sub_account_name,
    isActive: val.is_active,
  }))

  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };
  const validation = yup.object({
    subaccName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    acHead:yup.object().required()
})
  const formik = useFormik({
    initialValues:{
    subaccName:"",
    acHead:null
    },
    validationSchema:validation,
    onSubmit: isEdit ? handleUpdate : handleCreate
    })
    const onCreate = () => {
      setOpen(true)
      formik.resetForm()
      setIsEdit(false)
    }
    function handleCreate(){
      const accData = {
        sub_account_name:formik.values.subaccName,
        acc_id:formik.values.acHead.id,
        is_active:active
      }
      setIsLoader(true);
        console.log(accData)
      axios.post('/v1/subaccounts',accData)
    .then(res=>{
      setOpen(false)
      getAccountsData()
      dispatch(setSnackbar(true, 'success','Created Successfully!'))
      setOpen(false)
      setIsLoader(false);
    })
    .catch(err=>{
      console.log(err)
      dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
      setIsLoader(false);
    })
    }
    function onEdit(e){
      console.log(e)
      setActiveId(e.id)
      setIsEdit(true)
      setOpen(true)
      setActive(e.isActive)
      _.filter(acHeadData, val=>val.id == e.idNo).map(val=>formik.setFieldValue('acHead', val))
      formik.setFieldValue('subaccName' , e.subName)
    }
    function handleUpdate(){
    const accData = {
        sub_account_name:formik.values.subaccName,
        acc_id:formik.values.acHead.id,
        is_active:active
        }
      setIsLoader(true);

       axios.put(`/v1/subaccounts/${activeId}`,accData)
     .then(res=>{
       setOpen(false)
       getAccountsData()
       dispatch(setSnackbar(true, 'success','Updated Successfully!'))
       setOpen(false)
      setIsLoader(false);

     })
     .catch(err=>{
       console.log(err)
       dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
       setIsLoader(false);
     
      })
    }
    function OnDelete(id){
      setOpenDialog(true)
      setActiveId(id)
    }  
    const handleDelete = () =>{
      setIsLoader(true);

      axios.delete(`/v1/subaccounts/${activeId}`)
      .then(res=>{
        setOpenDialog(false)
        getAccountsData()
        console.log(res)
      setIsLoader(false);
      setOpen(false)
        dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
      setIsLoader(false);

      })
    }
    const getAccountsData = () =>{
      setIsLoader(true);

      axios.get(`/v1/subaccounts/${rowsPerPage}/${page + 1}`)
      .then(res=>{
        console.log(res)
        setData(res.data.data)
        setPageCount(res.data.meta.pagination.total)
      setIsLoader(false);

      })
      .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true, 'error', err.response.data.message))
        setIsLoader(false);
      
      })
    }
    const getSupplierData = () => {
        axios.get(`/v1/accountmaster`)
        .then((res) => {
            setAcHeadData(res.data)
        })
        .catch((err) => {console.log(err);dispatch(setSnackbar(true,'error',err.response.data.error))})
      }
    console.log(formik.errors)
    useEffect(() => {
      
      getAccountsData()
    },[rowsPerPage, page, search])
    useEffect(() => {
        getSupplierData()
    },[])
    console.log(data)
  return (
    <Grid className="">
      <Helmet>
        <title>
        Sub Account
        </title>
      </Helmet>
      <Typography variant="h5">Sub Account Master</Typography>
      {!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
{open &&
        <Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
          <Grid container spacing={2}>
          <Grid item xs={12} md={4} lg={3}>
          <CustomdropDown
                id="acHead"
                data={acHeadData}
                optionLabel={(option) => option.acname}
                value={formik.values.acHead}
                onchange={(e, value) => {
                  formik.setFieldValue("acHead", value);
                }}
                optionEqual={(option, value) => option.acname === value.acname}
                placeholder="Select Acc Head"
                helperText={formik.touched.acHead && formik.errors.acHead}
                errorMsg={
                  formik.touched.acHead && Boolean(formik.errors.acHead)
                }
                title="Account Head"
              />
        </Grid>
          <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='subaccName' value={formik.values.subaccName} title='Sub Account Name' multiple={false} placeholder='Enter Sub Account type' onchange={formik.handleChange} errorMsg={formik.touched.subaccName && Boolean(formik.errors.subaccName)} helperText={formik.touched.subaccName && formik.errors.subaccName}/>
      </Grid>
      <Grid item xs={12} md={4} lg={3} className="flex items-center">
              <FormControlLabel control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
            </Grid>
  {/* <Grid item xs={12} md={4} lg={3} className="flex items-center">
              <FormControlLabel control={<Checkbox />} label="Active" />
            </Grid> */}
          </Grid>
        </Modal>
      }
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader} /> */}
    </Grid>
  );
};

export default SubAccountMaster;
